export const APPLY_CQL_FILTER = "APPLY_CQL_FILTER";

export const applyCqlFilterAction = (cqlFilter: string) => {
    return {
        type: APPLY_CQL_FILTER,
        cqlFilter: cqlFilter,
    };
};
